// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { ElectricMetersRoutingModule } from './electric-meters-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { ElectricMetersListComponent } from 'src/app/modules/electric-meters/pages/electric-meters-list/electric-meters-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    ElectricMetersRoutingModule,
    // PublicModule,
  ],
  declarations: [
    ElectricMetersListComponent,
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class ElectricMetersModule { }
